import {
  createStore,
  combineReducers,
  applyMiddleware,
} from "@reduxjs/toolkit";
import { composeWithDevTools } from "redux-devtools-extension";

import thunk from "redux-thunk";
import medAppApi from "../api/medAppApi";
import { RootState, Services } from "../types";
import { configureEpic } from "./epics";
import { persistStore, persistReducer, PersistConfig } from "redux-persist";
import { reducer as formReducer } from 'redux-form';
import { logger } from "./middleware";
import appReducer from "../modules/app/store/appReducer";
import authReducer from "../modules/auth/store/authReducer";
import dashboardReducer from "../modules/admin/store/dashboardReducer";
import userActivitiesReducer from "../modules/user-activities/store/userActivitiesReducer";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import contractorDashboardReducer from "../modules/contractors/store/dashboardReducer";
import { setLoading } from "../modules/app/store/actions";

const persistConfig: PersistConfig<RootState> = {
  key: "root",
  storage,
  whitelist: ["app"],
};

function configureStore(initialState: RootState & { _persist: any }) {
  let s: any;
  const rootReducer = combineReducers({
    app: appReducer,
    auth: authReducer,
    form: formReducer,
    dashboard: dashboardReducer,
    contractor: contractorDashboardReducer,
    userActivities: userActivitiesReducer,
    
  });

  const services: Services = {
    api: medAppApi,
    getStore: () => s,
  };
  const { rootEpic, epicMiddleware } = configureEpic(services);
  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const baseMiddleWare = applyMiddleware(...[thunk, logger, epicMiddleware]);

  s = createStore(
    persistedReducer,
    initialState,
    composeWithDevTools(baseMiddleWare)
  );
  epicMiddleware.run(rootEpic);
  return s;
}

// export default;
const func = () => {
  let store = configureStore({
    _persist: undefined,
    app: {
      isLoading: false,
    },
    auth: {
      isLoading: false,
    },
  }  as any);
  let persistor = persistStore(store);
  store.dispatch(setLoading(true));
  return { store, persistor };
};

export default func;
